import * as React from 'react';
import { Draggable } from 'react-beautiful-dnd';

// import makeStyles from '@material-ui/core/styles/makeStyles';
import ListItem from '@material-ui/core/ListItem';
//import ListItemAvatar from '@material-ui/core/ListItemAvatar';
//import ListItemText from '@material-ui/core/ListItemText';
import RateCard from '../Cards/RateCard/RateCard';

const DraggableListItem = ({ item, index, handleDeleteRate, currency }) => {
  return (
    <Draggable draggableId={item.id.toString()} index={index}>
      {(provided, snapshot) => (
        <ListItem
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <RateCard 
            item={item} 
            handleDeleteRate={handleDeleteRate} 
            currency={currency}
          />
        </ListItem>
      )}
    </Draggable>
  );
};

export default DraggableListItem;
